import Constant from '@/const';
import axios from 'axios';

const getRecipeByIdAndCategory = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/patient/recipe/${params.id}/${params.category}`),
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export default getRecipeByIdAndCategory;
